<template>
  <div>
    <Wrapper
      :showContent="status === 200"
      label="نمونه رسید پرداخت"
      :loading="loading"
      :loadingText="loadingText"
      :items="items"
    >
      <template slot="header">
        <p v-if="status === 200" class="text-justify lh_30" v-html="caption2" />
        <b-alert :show="status === 202" variant="info" class="font-weight-bold">
          <i class="fas fa-info-circle fa-lg mr-2" />
          <span v-text="message" />
        </b-alert>
      </template>
      <template v-if="status === 200" slot="footer">
        <p class="text-justify lh_30" v-html="caption3" />
        <p class="text-justify lh_30" v-text="generatePaymentCaption" />
      </template>
      <template slot="buttons">
        <b-button
          class="mx-2"
          variant="outline-danger"
          :to="{ name: `taskUserPage` }"
          v-text="$lang.back_to_activity"
        />
        <b-button
          v-if="status === 200"
          class="mx-2"
          @click="postPayment"
          variant="primary"
          :disabled="loading"
        >
          <span v-if="!loading">پرداخت آنلاین</span>
          <span v-else>
            <b-spinner small></b-spinner>
            {{ $lang.redirect_bank }}
          </span>
        </b-button>
      </template>
    </Wrapper>
    <form
      class="visible-hidden"
      ref="form"
      :action="$config.resources.payment_melat_bank"
      method="post"
    >
      <input type="text" v-model="request.saleOrderId" name="SaleOrderId" />
      <input type="text" v-model="request.refId" name="RefId" />
      <input type="text" v-model="request.resCode" name="ResCode" />
      <input
        type="text"
        v-model="request.SaleReferenceId"
        name="SaleReferenceId"
      />
    </form>
  </div>
</template>

<script>
import Wrapper from "./Wrapper";
import { pathOr } from "ramda";

export default {
  inject: ["paymentRepository"],
  components: {
    Wrapper,
  },
  data() {
    return {
      status: null,
      message: "",
      items: {},
      loading: false,
      loadingText: this.$lang.receiving_data,
      request: {},
      caption2: `لطفا نسبت به پرداخت هزینه فرایند، از طریق دکمه <b class="text-primary">"پرداخت آنلاین"</b> اقدام کرده و منتظر بمانید تا تاییدیه بانک صادر شده و به صفحه‌ی <b class="text-primary">"رسید پرداخت"</b> مطابق نمونه زیر باز گردید. در صورت بازگشت به صفحه‌ی <b class="text-primary">"رسید پرداخت"</b> مطابق نمونه زیر عملیات پرداخت بصورت صحیح انجام شده است و شما می‌توانید با انتخاب دکمه <b class="text-primary">"بازگشت به صفحه فعالیت"</b> به لیست فعالیت‌ها بازگشت نموده و سپس بر روی گزینه تایید پایان فعالیت کلیک کنید تا فرایند پرداخت کامل شود.`,
      caption3: `در هر صورت چنانچه در عملیات پرداخت خطایی صورت گیرد و اطلاعات پرداخت طبق صفحه <b class="text-primary">"رسید پرداخت"</b> مطابق نمونه بالا مشاهده نشود، حتی اگر مبلغ از حساب شما کسر شود، عملیات پرداخت کامل نشده و مبلغ کسر شده پس از حداکثر 72 ساعت به حساب شما عودت داده می‌شود.`,
    };
  },
  computed: {
    generatePaymentCaption() {
      const captions = {
        jazbLang: "",
        goharshadLang: "",
        gazLang: "",
        rasaLang: "",
        talentcentralLang: "",
      };
      const key = this.$config.projectName;
      return pathOr("", [key], captions);
    },
  },
  created() {
    this.getPayment();
  },
  methods: {
    pathOr,
    async getPayment() {
      const termStateCode = pathOr(null, ["termStateCode"], this.$route.params);
      if (!termStateCode) return;

      try {
        this.loading = true;
        this.loadingText = this.$lang.receiving_data;
        const response = await this.paymentRepository.list(termStateCode);
        const data = { ...pathOr({}, ["data", "data"], response) };
        this.items = { ...data, amount: pathOr(0, ["cost"], data) };
        this.status = response.status;
        this.message = response.data.message;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async postPayment() {
      const term_state_code = pathOr(null, ["term_state_code"], this.items);
      if (!term_state_code) return;

      try {
        this.loading = true;
        this.loadingText = this.$lang.sending_data;
        const payload = {
          term_state_code,
          system: process.env.VUE_APP_PROJECT_NAME,
        };
        const response = await this.paymentRepository.create(payload);
        this.request = { ...pathOr({}, ["data", "data"], response) };
        const gateName = pathOr(null, ["gate_name"], this.request);
        const startPay = pathOr(null, ["StartPay"], this.request);
        if (gateName === "zarinpal") {
          window.open(startPay, "_blank");
        } else {
          setTimeout(() => {
            this.$refs.form.submit();
          }, 300);
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
